import {onValue, ref, update} from 'firebase/database'
import {Icon} from 'leaflet/dist/leaflet-src.esm'
import {isEmpty} from 'lodash'
import React, {useEffect, useMemo, useRef, useState} from 'react'
import {MapContainer, Marker, TileLayer, useMap} from 'react-leaflet'
import {db} from './firebase'
import './index.css'

const Map = ({setMarkers}) => {
  const [pois, setPois] = useState([])
  const map = useMap()

  useEffect(() => {
    return onValue(ref(db, '/pois'), (snapshot) => {
      const p = snapshot.val()
      setPois(Object.keys(p).map(k => ({name: k, ...p[k]})))
    })
  }, [])

  useEffect(() => {
    if (isEmpty(pois)) return
    map.options.maxBoundsViscosity = 1.0
    map.setMaxBounds(map.getBounds())

    const spanWidth = map.getSize().x
    const spanHeight = map.getSize().y

    const scaleFactor = 1.3
    setMarkers(pois.map((poi) => {
      const x = spanWidth * (poi.x) / 2800
      const y = spanHeight * (poi.y) / 1752

      const w = poi.width / scaleFactor
      const h = poi.height / scaleFactor
      return {
        name: poi.name,
        icon: new Icon({
          iconUrl: `/pois/${poi.name}.png`,
          iconSize: {x: w, y: h},
        }),
        position: poi.lat ? {lat: poi.lat, lng: poi.lng} : map.containerPointToLatLng({x, y})
      }
    }))
  }, [map, setMarkers, pois])

  return null
}

const DraggableMarker = ({center, name, icon}) => {
  const [position, setPosition] = useState(center)
  const markerRef = useRef(null)
  const eventHandlers = useMemo(
    () => ({
      async dragend () {
        const marker = markerRef.current
        if (marker != null) {
          setPosition(marker.getLatLng())
          const updates = {}
          updates[`pois/${name}/lat`] = marker.getLatLng().lat
          updates[`pois/${name}/lng`] = marker.getLatLng().lng
          await update(ref(db), updates)
        }
      },
    }), [name])

  return (
    <Marker draggable={true}
            eventHandlers={eventHandlers}
            position={position}
            name={name}
            icon={icon}
            ref={markerRef}>
    </Marker>
  )
}

const App = () => {
  const [markers, setMarkers] = useState([])

  return (
    <MapContainer center={[40, -22]}
                  minZoom={3}
                  zoom={3}
                  maxZoom={5}>
      <TileLayer url="/tiles/{z}/{y}/{x}.jpg" />
      {markers.map((marker, index) => process.env.NODE_ENV === 'development' && process.env.REACT_APP_EDIT === 'true' ? <DraggableMarker key={index}
                                                                                                                                         name={marker.name}
                                                                                                                                         icon={marker.icon}
                                                                                                                                         center={marker.position} /> :
        <Marker key={index}
                eventHandlers={{
                  click: () => {
                    window.parent.postMessage(marker.name, '*')
                  }
                }}
                name={marker.name}
                icon={marker.icon}
                                                                                                                                     position={marker.position} />
      )}
      <Map setMarkers={setMarkers} />
    </MapContainer>
  )
}

export default App
